import BuildTypes from 'src/constants/BuildTypeConstants';
import Settings from 'src/Settings';
import ConnectandPayDescriptor from './recentorder-canteen-descriptor';
import RedesignDescriptor from './recentorder-redesign-descriptor';
import RefiveDescriptor from './recentorder-refive-descriptor';

const typeDescriber = {
  [BuildTypes.default]: RedesignDescriptor,
  [BuildTypes.canteen]: ConnectandPayDescriptor,
  [BuildTypes.companykitchen]: ConnectandPayDescriptor,
  [BuildTypes.refive]: RefiveDescriptor,
};

export function getRecentOrderDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
